// From https://primer.style/octicons
import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon'
import * as MuiIcons from '@material-ui/icons'

export const aiidaBlue = '#84D3DB'
export const aiidaGreen = '#A0D58A'
export const aiidaOrange = '#FFB27C'

export function AiiDAIcon200({
  width,
  height,
  arcColor
}: {
  width: number
  height: number
  arcColor: string
}): JSX.Element {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 -21 200 221"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
    >
      <g>
        <title>background</title>
        <rect
          fill="none"
          id="canvas_background"
          height="402"
          width="582"
          y="-1"
          x="-1"
        />
      </g>
      <g>
        <title>Dashboard Arc</title>
        <g
          id="svg_7"
          fill={arcColor}
          opacity="0.8"
          transform="rotate(180) translate(-170,32) scale(0.29, -0.28)"
        >
          <path
            d="M492.719,207.208c-0.108-0.575-0.27-1.146-0.492-1.702c-0.223-0.558-0.507-1.069-0.837-1.537
				c-12.787-30.616-31.365-58.265-54.348-81.565c-0.324-0.482-0.701-0.944-1.135-1.378s-0.896-0.811-1.378-1.135
				C388.233,74.226,324.764,45.933,255,45.933c-33.418,0-65.389,6.5-94.725,18.281c-0.575,0.108-1.146,0.27-1.701,0.492
				c-0.557,0.223-1.069,0.507-1.537,0.837c-30.616,12.787-58.265,31.365-81.565,54.348c-0.482,0.324-0.944,0.701-1.378,1.135
				s-0.812,0.896-1.135,1.378C27.293,168.7-1,232.169-1,301.933c0,58.027,18.773,113.493,55.467,158.72
				c1.707,2.56,4.267,3.413,6.827,3.413h387.413c2.56,0,5.12-0.853,6.827-3.413C492.227,415.427,511,359.96,511,301.933
				C511,268.515,504.5,236.544,492.719,207.208z M445.293,447H65.56c-11.539-14.88-21.122-30.844-28.695-47.616l23.575-9.557
				c4.267-1.707,5.973-6.827,4.267-11.093c-1.707-4.267-6.827-5.973-11.093-4.267l-23.11,9.369
				c-8.574-23.342-13.394-48.021-14.278-73.369H75.8c5.12,0,8.533-3.413,8.533-8.533S80.92,293.4,75.8,293.4H16.237
				c0.957-26.907,6.416-52.715,15.648-76.694L55.32,226.84c0.853,0.853,2.56,0.853,3.413,0.853c3.413,0,5.973-1.707,7.68-5.12
				c1.707-4.267,0-9.387-4.267-11.093l-23.672-10.237c10.699-22.831,24.906-43.721,41.922-61.967l17.59,17.59
				c1.707,1.707,3.413,2.56,5.973,2.56s4.267-0.853,5.973-2.56c3.413-3.413,3.413-8.533,0-11.947l-17.59-17.59
				c19.117-17.828,41.131-32.581,65.244-43.438l9.52,23.482c0.853,3.413,4.267,5.12,7.68,5.12c0.853,0,1.707,0,3.413-0.853
				c4.267-1.707,5.973-6.827,4.267-11.093l-9.329-23.012c23.021-8.463,47.679-13.452,73.329-14.364v59.563
				c0,5.12,3.413,8.533,8.533,8.533s8.533-3.413,8.533-8.533V63.17c26.907,0.957,52.715,6.416,76.694,15.648l-10.134,23.436
				c-1.707,4.267,0,9.387,4.267,11.093c0.853,0.853,2.56,0.853,3.413,0.853c3.413,0,6.827-2.56,7.68-5.12l10.237-23.672
				c22.831,10.699,43.721,24.906,61.967,41.922l-17.59,17.59c-3.413,3.413-3.413,8.533,0,11.947c1.707,1.707,3.413,2.56,5.973,2.56
				c1.707,0,4.267-0.853,5.973-2.56l17.59-17.59c17.828,19.117,32.581,41.131,43.438,65.244l-23.482,9.52
				c-4.267,1.707-5.973,6.827-4.267,11.093c0.853,3.413,4.267,5.12,7.68,5.12c0.853,0,1.707-0.853,3.413-0.853l23.013-9.329
				c8.463,23.021,13.452,47.679,14.364,73.329H434.2c-5.12,0-8.533,3.413-8.533,8.533s3.413,8.533,8.533,8.533h59.575
				c-0.927,26.593-6.172,52.45-15.418,76.799l-23.677-10.239c-4.267-1.707-9.387,0-11.093,4.267c-1.707,4.267,0,9.387,4.267,11.093
				l23.981,10.37C464.644,418.298,455.773,433.121,445.293,447z"
          />
        </g>
      </g>
      <g>
        <title>Main Icon</title>
        <g id="svg_1" fill="#000000" transform="translate(0, 200) scale(0.1, -0.1)">
          <path
            fill="#84D3DB"
            id="svg_2"
            d="m1369.99536,994.72168c-75,-21.00024 -101,-34.00024 -161,-80.00024c-68,-51.99976 -135,-150.99976 -153,-222.99976l-6,-28l150,0l150,0l0,60c0,33 4,60 9,60c5,0 43,-20 85,-45c42,-24 106,-61 143,-81c81,-45.00006 143,-83.00006 143,-88.00006c0,-3 -24,-18 -52,-33c-71,-39 -116,-65 -225,-129c-51,-30 -94,-54 -97,-54c-3,0 -6,29 -6,65l0,65l-151,0c-166,0 -152,6 -133,-61c14,-50 82,-144.99988 135,-188.99988c87,-72 151,-94 279,-95c88,0 115,4 163,23c119,48 224,165.99988 261,290.99988c30,102 13,250.00006 -36,323.00006c-10,14 -18,31 -18,36c0,16 -127,129.99976 -168,150.99976c-49,24 -158,51.00024 -208,50.00024c-21,0 -68,-8 -104,-18z"
          />
        </g>
        <g
          id="svg_4"
          fill="#000000"
          transform="rotate(-120, 96.4437, 55.2508) translate(0, 200) scale(0.1, -0.1)"
        >
          <path
            fill="#FFB27C"
            id="svg_3"
            d="m849.99731,1866.47681c-75,-21 -101,-34 -161,-80c-68,-52 -135,-150.99988 -153,-222.99988l-6,-28l150,0l150,0l0,60c0,33 4,59.99988 9,59.99988c5,0 43,-19.99988 85,-44.99988c42,-24 105.99805,-61 142.99805,-81c81,-45 143,-83 143,-88c0,-3 -24,-18 -52,-33c-71,-39 -116,-65 -224.99805,-129c-51,-30 -94,-54 -97,-54c-3,0 -6,29 -6,65l0,65l-151,0c-166,0 -152,6 -133,-61c14,-50 82,-145 135,-189c87,-72 151,-93.99939 279,-94.99939c87.99805,0 114.99805,4 162.99805,22.99939c119,48 224,166 261,291c30,102 13,250 -36,322.99988c-10,14 -18,31 -18,36c0,16 -127,130 -168,151c-49,24 -158,51 -207.99805,50c-21,0 -68,-8 -104,-18z"
          />
        </g>
        <g
          id="svg_6"
          fill="#000000"
          transform="rotate(120, 50.1463, 142.426) translate(0, 200) scale(0.1, -0.1)"
        >
          <path
            fill="#A0D58A"
            id="svg_5"
            d="m387.00516,994.72168c-75,-21.00024 -101,-34.00024 -161,-80.00024c-68,-51.99976 -135,-150.99976 -153,-222.99976l-6,-28l150,0l150,0l0,60c0,33 4,60 9,60c5,0 43,-20 85,-45c42,-24 105.99997,-61 142.99997,-81c81,-45.00006 143,-83.00006 143,-88.00006c0,-3 -24,-18 -52,-33c-71,-39 -116,-65 -224.99997,-129c-51,-30 -94,-54 -97,-54c-3,0 -6,29 -6,65l0,65l-151,0c-166,0 -152,6 -133,-61c14,-50 82,-144.99988 135,-188.99988c87,-72 151,-94 279,-95c87.99997,0 114.99997,4 162.99997,23c119,48 224,165.99988 261,290.99988c30,102 13,250.00006 -36,323.00006c-10,14 -18,31 -18,36c0,16 -127,129.99976 -168,150.99976c-49,24 -158,51.00024 -207.99997,50.00024c-21,0 -68,-8 -104,-18z"
          />
        </g>
      </g>
    </svg>
  )
}

AiiDAIcon200.defaultProps = {
  width: 200,
  height: 200,
  arcColor: 'black'
}

// TODO better value type, custom icons (https://primer.style/octicons/packages/react)
export const ElementIconMap: { [key: string]: JSX.Element } = {
  default: <MuiIcons.DeviceUnknown />,
  folder: <MuiIcons.Inbox />,
  'data.array': <MuiIcons.GridOn />,
  'data.bool': <MuiIcons.CheckCircle />,
  'data.cif': <MuiIcons.ScatterPlot />,
  'data.code': <MuiIcons.Code />,
  'data.dict': <MuiIcons.ViewList />,
  'data.float': <MuiIcons.AllInclusive />,
  'data.folder': <MuiIcons.Inbox />,
  'data.int': <MuiIcons.LooksOne />,
  'data.list': <MuiIcons.List />,
  'data.numeric': <MuiIcons.PlusOne />,
  'data.orbital': <MuiIcons.BlurOn />,
  'data.remote': <MuiIcons.OpenInNew />,
  'data.str': <MuiIcons.FormatColorText />,
  'data.structure': <MuiIcons.Grain />,
  'process.calculation': <RocketIcon />,
  'process.process': <RocketIcon />,
  'process.workflow': <GitBranchIcon /> // <MuiIcons.Share />,
}

export function RocketIcon(): JSX.Element {
  return (
    <SvgIcon>
      <path
        fillRule="evenodd"
        d="M20.322.75a10.75 10.75 0 00-7.373 2.926l-1.304 1.23A23.743 23.743 0 0010.103 6.5H5.066a1.75 1.75 0 00-1.5.85l-2.71 4.514a.75.75 0 00.49 1.12l4.571.963c.039.049.082.096.129.14L8.04 15.96l1.872 1.994c.044.047.091.09.14.129l.963 4.572a.75.75 0 001.12.488l4.514-2.709a1.75 1.75 0 00.85-1.5v-5.038a23.741 23.741 0 001.596-1.542l1.228-1.304a10.75 10.75 0 002.925-7.374V2.499A1.75 1.75 0 0021.498.75h-1.177zM16 15.112c-.333.248-.672.487-1.018.718l-3.393 2.262.678 3.223 3.612-2.167a.25.25 0 00.121-.214v-3.822zm-10.092-2.7L8.17 9.017c.23-.346.47-.685.717-1.017H5.066a.25.25 0 00-.214.121l-2.167 3.612 3.223.679zm8.07-7.644a9.25 9.25 0 016.344-2.518h1.177a.25.25 0 01.25.25v1.176a9.25 9.25 0 01-2.517 6.346l-1.228 1.303a22.248 22.248 0 01-3.854 3.257l-3.288 2.192-1.743-1.858a.764.764 0 00-.034-.034l-1.859-1.744 2.193-3.29a22.248 22.248 0 013.255-3.851l1.304-1.23zM17.5 8a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm-11 13c.9-.9.9-2.6 0-3.5-.9-.9-2.6-.9-3.5 0-1.209 1.209-1.445 3.901-1.49 4.743a.232.232 0 00.247.247c.842-.045 3.534-.281 4.743-1.49z"
      ></path>
    </SvgIcon>
  )
}

export function GitBranchIcon(): JSX.Element {
  return (
    <SvgIcon>
      <path
        fillRule="evenodd"
        d="M5.75 21a1.75 1.75 0 110-3.5 1.75 1.75 0 010 3.5zM2.5 19.25a3.25 3.25 0 106.5 0 3.25 3.25 0 00-6.5 0zM5.75 6.5a1.75 1.75 0 110-3.5 1.75 1.75 0 010 3.5zM2.5 4.75a3.25 3.25 0 106.5 0 3.25 3.25 0 00-6.5 0zM18.25 6.5a1.75 1.75 0 110-3.5 1.75 1.75 0 010 3.5zM15 4.75a3.25 3.25 0 106.5 0 3.25 3.25 0 00-6.5 0z"
      ></path>
      <path
        fillRule="evenodd"
        d="M5.75 16.75A.75.75 0 006.5 16V8A.75.75 0 005 8v8c0 .414.336.75.75.75z"
      ></path>
      <path
        fillRule="evenodd"
        d="M17.5 8.75v-1H19v1a3.75 3.75 0 01-3.75 3.75h-7a1.75 1.75 0 00-1.75 1.75H5A3.25 3.25 0 018.25 11h7a2.25 2.25 0 002.25-2.25z"
      ></path>
    </SvgIcon>
  )
}

export function OptimadeIcon({
  width = 180,
  height = 180,
  singleColor
}: {
  width?: number
  height?: number
  singleColor?: string
}): JSX.Element {
  return (
    <SvgIcon>
      <svg
        version="1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 400 400"
        width={width}
        height={height}
      >
        <g
        // transform="matrix(3.5294118,0,0,3.5294118,-5.2941176,-5.2938861)"
        >
          <line
            y2="7.9474411"
            x2="38"
            y1="14.5"
            x1="27"
            style={{
              stroke: singleColor ? singleColor : '#9ed700',
              strokeWidth: 1.14999998
            }}
          />
          <line
            y2="46.052559"
            x2="38"
            y1="33.25"
            x1="37.825317"
            style={{
              stroke: singleColor ? singleColor : '#00acd9',
              strokeWidth: 1.14999998
            }}
          />
          <line
            y2="27"
            x2="5"
            y1="33.25"
            x1="16.174683"
            style={{
              stroke: singleColor ? singleColor : '#7a2dd0',
              strokeWidth: 1.14999998
            }}
          />
          <line
            y2="46.052559"
            x2="38"
            y1="27"
            x1="49"
            style={{
              stroke: singleColor ? singleColor : '#00acd9',
              strokeWidth: 1.14999998
            }}
          />
          <line
            y2="46.052559"
            x2="16"
            y1="46.052559"
            x1="38"
            style={{ stroke: singleColor ? singleColor : '#e8e8e8', strokeWidth: 2 }}
          />
          <line
            y2="27"
            x2="5"
            y1="46.052559"
            x1="16"
            style={{
              stroke: singleColor ? singleColor : '#7a2dd0',
              strokeWidth: 1.14999998
            }}
          />
          <line
            y2="7.9474411"
            x2="16"
            y1="27"
            x1="5"
            style={{ stroke: singleColor ? singleColor : '#e8e8e8', strokeWidth: 2 }}
          />
          <line
            y2="7.9474411"
            x2="38"
            y1="7.9474411"
            x1="16"
            style={{
              stroke: singleColor ? singleColor : '#9ed700',
              strokeWidth: 1.14999998
            }}
          />
          <line
            y2="27"
            x2="49"
            y1="7.9474411"
            x1="38"
            style={{ stroke: singleColor ? singleColor : '#e8e8e8', strokeWidth: 2 }}
          />
          <circle
            r="3.5"
            cy="27"
            cx="49"
            style={{ fill: singleColor ? singleColor : '#00acd9' }}
          />
          <circle
            r="3.5"
            cy="46.052559"
            cx="38"
            style={{ fill: singleColor ? singleColor : '#00acd9' }}
          />
          <circle
            id="circle367"
            r="3.5"
            cy="46.052559"
            cx="16"
            style={{ fill: singleColor ? singleColor : '#7a2dd0' }}
          />
          <circle
            r="3.5"
            cy="27"
            cx="5"
            style={{ fill: singleColor ? singleColor : '#7a2dd0' }}
          />
          <circle
            r="3.5"
            cy="7.9474411"
            cx="16"
            style={{ fill: singleColor ? singleColor : '#9ed700' }}
          />
          <circle
            r="3.5"
            cy="7.9474411"
            cx="38"
            style={{ fill: singleColor ? singleColor : '#9ed700' }}
          />
          <line
            y2="33.25"
            x2="16.174683"
            y1="39.5"
            x1="27"
            style={{ stroke: singleColor ? singleColor : '#ff414d', strokeWidth: 1 }}
          />
          <line
            y2="20.75"
            x2="16.174683"
            y1="33.25"
            x1="16.174683"
            style={{ stroke: singleColor ? singleColor : '#ff414d', strokeWidth: 1 }}
          />
          <line
            y2="14.5"
            x2="27"
            y1="20.75"
            x1="16.174683"
            style={{ stroke: singleColor ? singleColor : '#ff414d', strokeWidth: 1 }}
          />
          <line
            y2="20.75"
            x2="37.825317"
            y1="14.5"
            x1="27"
            style={{ stroke: singleColor ? singleColor : '#ff414d', strokeWidth: 1 }}
          />
          <line
            y2="33.25"
            x2="37.825317"
            y1="20.75"
            x1="37.825317"
            style={{ stroke: singleColor ? singleColor : '#ff414d', strokeWidth: 1 }}
          />
          <line
            y2="39.5"
            x2="27"
            y1="33.25"
            x1="37.825317"
            style={{ stroke: singleColor ? singleColor : '#ff414d', strokeWidth: 1 }}
          />
          <circle
            r="2.5"
            cy="39.5"
            cx="27"
            style={{ fill: singleColor ? singleColor : '#ff414d' }}
          />
          <circle
            r="2.5"
            cy="33.25"
            cx="16.174683"
            style={{ fill: singleColor ? singleColor : '#ff414d' }}
          />
          <circle
            r="2.5"
            cy="20.75"
            cx="16.174683"
            style={{ fill: singleColor ? singleColor : '#ff414d' }}
          />
          <circle
            r="2.5"
            cy="14.5"
            cx="27"
            style={{ fill: singleColor ? singleColor : '#ff414d' }}
          />
          <circle
            r="2.5"
            cy="20.75"
            cx="37.825317"
            style={{ fill: singleColor ? singleColor : '#ff414d' }}
          />
          <circle
            r="2.5"
            cy="33.25"
            cx="37.825317"
            style={{ fill: singleColor ? singleColor : '#ff414d' }}
          />
        </g>
      </svg>
    </SvgIcon>
  )
}

// "#61DAFB"
export function ReactIcon(): JSX.Element {
  return (
    <SvgIcon>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="48"
        height="46"
        viewBox="6 2.6 24 24"
        version="1.1"
      >
        <g id="surface1" fill="black">
          <path
            // style=" stroke:none;fill-rule:nonzero;fill:rgb(38.039216%,85.490196%,98.431373%);fill-opacity:1;"
            d="M 18.988281 8.46875 C 18.988281 7.539062 17.832031 6.660156 16.050781 6.113281 C 16.460938 4.296875 16.28125 2.851562 15.476562 2.390625 C 15.292969 2.28125 15.074219 2.230469 14.839844 2.230469 L 14.839844 2.867188 C 14.96875 2.867188 15.074219 2.894531 15.164062 2.941406 C 15.550781 3.164062 15.71875 4.011719 15.589844 5.101562 C 15.558594 5.371094 15.503906 5.652344 15.441406 5.941406 C 14.882812 5.804688 14.273438 5.699219 13.632812 5.632812 C 13.25 5.101562 12.851562 4.625 12.449219 4.203125 C 13.378906 3.339844 14.25 2.863281 14.84375 2.863281 L 14.84375 2.226562 C 14.058594 2.226562 13.03125 2.789062 11.996094 3.757812 C 10.957031 2.792969 9.933594 2.238281 9.148438 2.238281 L 9.148438 2.875 C 9.738281 2.875 10.613281 3.347656 11.542969 4.207031 C 11.144531 4.625 10.746094 5.101562 10.367188 5.632812 C 9.722656 5.699219 9.113281 5.804688 8.554688 5.945312 C 8.488281 5.660156 8.441406 5.382812 8.40625 5.117188 C 8.273438 4.027344 8.4375 3.179688 8.820312 2.953125 C 8.90625 2.902344 9.019531 2.878906 9.148438 2.878906 L 9.148438 2.242188 C 8.910156 2.242188 8.695312 2.292969 8.503906 2.402344 C 7.707031 2.863281 7.527344 4.304688 7.9375 6.117188 C 6.167969 6.664062 5.011719 7.542969 5.011719 8.46875 C 5.011719 9.394531 6.171875 10.273438 7.949219 10.820312 C 7.539062 12.636719 7.722656 14.082031 8.527344 14.542969 C 8.710938 14.652344 8.925781 14.703125 9.167969 14.703125 C 9.949219 14.703125 10.976562 14.144531 12.011719 13.171875 C 13.050781 14.136719 14.074219 14.691406 14.859375 14.691406 C 15.097656 14.691406 15.316406 14.640625 15.503906 14.53125 C 16.304688 14.070312 16.484375 12.628906 16.070312 10.816406 C 17.835938 10.273438 18.988281 9.390625 18.988281 8.46875 Z M 15.28125 6.5625 C 15.175781 6.929688 15.042969 7.3125 14.894531 7.691406 C 14.777344 7.460938 14.65625 7.234375 14.523438 7.003906 C 14.390625 6.777344 14.253906 6.554688 14.113281 6.335938 C 14.515625 6.398438 14.90625 6.472656 15.28125 6.5625 Z M 13.976562 9.605469 C 13.753906 9.988281 13.527344 10.355469 13.289062 10.695312 C 12.863281 10.730469 12.433594 10.75 12 10.75 C 11.570312 10.75 11.140625 10.730469 10.71875 10.699219 C 10.484375 10.359375 10.253906 9.996094 10.03125 9.613281 C 9.8125 9.238281 9.617188 8.859375 9.4375 8.476562 C 9.613281 8.09375 9.8125 7.710938 10.027344 7.335938 C 10.25 6.949219 10.476562 6.585938 10.714844 6.246094 C 11.136719 6.207031 11.570312 6.1875 12 6.1875 C 12.429688 6.1875 12.863281 6.207031 13.285156 6.242188 C 13.519531 6.582031 13.75 6.945312 13.972656 7.328125 C 14.1875 7.703125 14.386719 8.082031 14.566406 8.464844 C 14.386719 8.847656 14.1875 9.230469 13.976562 9.605469 Z M 14.894531 9.234375 C 15.050781 9.613281 15.179688 9.996094 15.289062 10.367188 C 14.914062 10.460938 14.523438 10.539062 14.117188 10.597656 C 14.253906 10.378906 14.394531 10.152344 14.527344 9.921875 C 14.65625 9.691406 14.777344 9.460938 14.894531 9.234375 Z M 12.007812 12.28125 C 11.742188 12.003906 11.476562 11.699219 11.214844 11.367188 C 11.472656 11.378906 11.734375 11.386719 12 11.386719 C 12.265625 11.386719 12.53125 11.378906 12.789062 11.367188 C 12.535156 11.699219 12.269531 12.003906 12.007812 12.28125 Z M 9.886719 10.597656 C 9.484375 10.539062 9.09375 10.464844 8.71875 10.371094 C 8.824219 10.003906 8.957031 9.625 9.105469 9.242188 C 9.222656 9.472656 9.34375 9.699219 9.476562 9.929688 C 9.609375 10.15625 9.746094 10.378906 9.886719 10.597656 Z M 11.992188 4.65625 C 12.257812 4.929688 12.523438 5.234375 12.785156 5.570312 C 12.527344 5.558594 12.265625 5.546875 12 5.546875 C 11.734375 5.546875 11.46875 5.554688 11.210938 5.570312 C 11.464844 5.234375 11.730469 4.929688 11.992188 4.65625 Z M 9.882812 6.335938 C 9.746094 6.558594 9.605469 6.78125 9.472656 7.011719 C 9.34375 7.242188 9.222656 7.46875 9.105469 7.699219 C 8.949219 7.316406 8.820312 6.933594 8.710938 6.5625 C 9.085938 6.472656 9.476562 6.398438 9.882812 6.335938 Z M 7.304688 9.914062 C 6.296875 9.480469 5.644531 8.914062 5.644531 8.46875 C 5.644531 8.019531 6.296875 7.449219 7.304688 7.023438 C 7.550781 6.917969 7.820312 6.824219 8.09375 6.734375 C 8.257812 7.292969 8.472656 7.875 8.738281 8.472656 C 8.472656 9.066406 8.261719 9.648438 8.105469 10.203125 C 7.820312 10.113281 7.554688 10.019531 7.304688 9.914062 Z M 8.839844 13.992188 C 8.453125 13.769531 8.285156 12.921875 8.414062 11.832031 C 8.445312 11.5625 8.496094 11.28125 8.558594 10.992188 C 9.117188 11.128906 9.726562 11.234375 10.367188 11.304688 C 10.753906 11.832031 11.152344 12.3125 11.554688 12.730469 C 10.625 13.597656 9.753906 14.070312 9.160156 14.070312 C 9.03125 14.066406 8.925781 14.042969 8.839844 13.992188 Z M 15.597656 11.816406 C 15.730469 12.90625 15.566406 13.757812 15.179688 13.980469 C 15.09375 14.03125 14.984375 14.054688 14.851562 14.054688 C 14.261719 14.054688 13.390625 13.585938 12.460938 12.726562 C 12.859375 12.304688 13.257812 11.828125 13.636719 11.300781 C 14.28125 11.230469 14.890625 11.125 15.449219 10.984375 C 15.515625 11.273438 15.566406 11.550781 15.597656 11.816406 Z M 16.695312 9.914062 C 16.449219 10.019531 16.179688 10.113281 15.90625 10.199219 C 15.742188 9.640625 15.527344 9.058594 15.261719 8.460938 C 15.527344 7.867188 15.738281 7.289062 15.894531 6.730469 C 16.179688 6.820312 16.445312 6.917969 16.695312 7.023438 C 17.703125 7.453125 18.355469 8.019531 18.355469 8.46875 C 18.355469 8.914062 17.703125 9.484375 16.695312 9.914062 Z M 9.148438 2.238281 Z M 9.148438 2.238281 "
          />
          <path
            // style=" stroke:none;fill-rule:nonzero;fill:rgb(38.039216%,85.490196%,98.431373%);fill-opacity:1;"
            d="M 13.300781 8.46875 C 13.300781 9.1875 12.71875 9.773438 12 9.773438 C 11.28125 9.773438 10.695312 9.1875 10.695312 8.46875 C 10.695312 7.746094 11.28125 7.160156 12 7.160156 C 12.71875 7.160156 13.300781 7.746094 13.300781 8.46875 Z M 13.300781 8.46875 "
          />
        </g>
      </svg>
    </SvgIcon>
  )
}
